import PrimeTimeUpdater from './PrimeTimeUpdater';

export default PrimeTimeUpdater;
